import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadBonusesActions from "../../store/actions/BulkUploadBonuses";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  "For the expire action, Please provide: driver_id, bonus_name, action, reason",
  "For the create action, Please provide: driver_id, bonus_name, action, reason, validity(in days), slabs_targets, slabs_amounts, startDateTime(UTC)",
  "For the create action, If there are multiple slabs, please provide slabs_targets & slabs_amounts in format as sample_csv file provided sequentially.",
  "For the create action, Please provide the slab_targets & slab_amounts in double inverted commas.",
  "For the create action, Please provide the startDateTime in UTC format in double inverted commas.",
  "For the create action, StartDateTime should be in the format: YYYY-MM-DD HH:MM:SS",
];

const BulkUploadBonusesDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkUploadBonusesBtn"
      uploadUrl="/upload-doc/ack"
      sampleURL="/sample/bulk_upload_bonuses.csv"
      id="BulkUploadBonusesModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Upload Bonuses"
      getUploadUrl={getBulkUploadUrl}
      action="BonusUpdate"
      serviceOwner="BONUS_SERVICE"
      useUserUploadedFilename={true}
      validationType={"BulkUploadBonuses"}
      addTimestampToFileName={true}
      acceptedFileFormat=".csv"
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkUploadBonusesActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadBonusesDashboard);
